import { Controller } from "@hotwired/stimulus"

// Story Favorite Controller
// Handles heart toggle with pulse animation
export default class extends Controller {
  static targets = ["button", "icon"]

  connect() {
    // Controller for any additional JS-based favorite animations
  }

  toggle(event) {
    // The actual toggle is handled by Turbo/form submission
    // This is for adding animation effects
    const button = event.currentTarget
    
    // Add pulse animation
    button.classList.add("animate-pulse")
    setTimeout(() => {
      button.classList.remove("animate-pulse")
    }, 300)
  }
}

